import React from "react";
import { Container, Typography, Box, Card, CardContent } from "@mui/material";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";

const GenericBrand = () => {
  return (
    <Box>
      {/* Hero Section with Image Overlay */}
      <Box
        sx={{
          position: "relative",
          height: "300px",
          width: "100%",
          overflow: "hidden",
          mb: 6,
        }}
      >
        {/* Background Image */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay
              zIndex: 1,
            },
          }}
        >
          <img
            src="/assets/images/generic.jpeg"
            alt="SAR Pharma Generic Medicines"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>

        {/* Overlay Content */}
        <Container
          maxWidth="lg"
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            zIndex: 2,
          }}
        >
          <LocalPharmacyIcon
            sx={{
              fontSize: 80,
              color: "white",
              mb: 3,
            }}
          />
          <Typography
            variant="h1"
            sx={{
              color: "white",
              fontWeight: 800,
              fontSize: { xs: "2.5rem", md: "4rem" },
              textAlign: "center",
              mb: 2,
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
            }}
          >
            Generic Brand
          </Typography>
        </Container>
      </Box>

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* Title Card */}
        <Card
          elevation={0}
          sx={{
            mb: 4,
            borderRadius: 4,
            background: "linear-gradient(135deg, #1976d2, #1565c0)",
            color: "white",
          }}
        >
          <CardContent sx={{ p: 4, backgroundColor: "#215d66" }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                lineHeight: 1.4,
                textAlign: "center",
              }}
            >
              SAR Pharma International takes pride in its commitment to
              providing a comprehensive range of pharmaceutical solutions,
              extending beyond international branded medicines.
            </Typography>
          </CardContent>
        </Card>

        {/* Description Card */}
        <Card
          elevation={0}
          sx={{
            borderRadius: 4,
            bgcolor: "white",
            boxShadow: "0 4px 24px rgba(0,0,0,0.1)",
          }}
        >
          <CardContent sx={{ p: 6 }}>
            <Box
              sx={{
                mb: 4,
                p: 4,
                bgcolor: "rgba(25, 118, 210, 0.04)",
                borderRadius: 2,
                border: "1px solid rgba(25, 118, 210, 0.1)",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.2rem",
                  lineHeight: 1.8,
                  color: "text.primary",
                }}
              >
                Our dedication to global healthcare extends to the supply of
                high-quality generic branded medicines sourced from reputable
                manufacturers in Bangladesh and other countries. By offering a
                diverse portfolio of generic pharmaceuticals, including
                oncology/anti-cancer medications, we aim to enhance
                accessibility to affordable yet efficacious treatment options
                worldwide.
              </Typography>
            </Box>

            <Typography
              variant="body1"
              sx={{
                fontSize: "1.2rem",
                lineHeight: 1.8,
                color: "text.secondary",
                fontStyle: "italic",
                textAlign: "center",
                maxWidth: "900px",
                mx: "auto",
              }}
            >
              Our quality assurance processes ensure that every product we
              supply adheres to the highest industry standards, fostering trust
              among our partners and reinforcing our reputation.
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default GenericBrand;
